<div class="ipm-wrapper">
    <div class="ipm-header">
        <div class="ipm-user">
            @if (showAvatar !== false) {
                @if (avatarUrl) {
                    <div class="ipm-avatar">
                        <img [src]="getAvatarUrl(avatarUrl)" [alt]="title" />
                    </div>
                } @else if (title) {
                    <div class="ipm-avatar">{{ getInitials(title) }}</div>
                }
            }
            <div class="ipm-meta">
                @if (title) { <div class="ipm-name">{{ title }}</div> }
                @if (subtitle) { <div class="ipm-date">{{ subtitle }}</div> }
            </div>
        </div>
        @if (fileName) {
            <div class="ipm-filename">{{ fileName }}</div>
        }
        <div class="ipm-actions">
            <button class="ipm-btn" (click)="zoomOut()" matTooltip="Zoom out">
                <mat-icon>remove</mat-icon>
            </button>
            <span class="ipm-zoom-label">{{ zoomPercent }}%</span>
            <button class="ipm-btn" (click)="zoomIn()" matTooltip="Zoom in">
                <mat-icon>add</mat-icon>
            </button>
            <button class="ipm-btn" (click)="resetZoom()" matTooltip="Reset zoom">
                <mat-icon>center_focus_strong</mat-icon>
            </button>
            <a [href]="imageUrl" download class="ipm-btn" matTooltip="Download">
                <mat-icon>download</mat-icon>
            </a>
        </div>
    </div>
    <div class="ipm-body-wrapper">
        @if (hasGallery && currentIndex > 0) {
            <button class="ipm-nav-btn ipm-nav-prev" (click)="goPrev()" matTooltip="Previous">
                <mat-icon>chevron_left</mat-icon>
            </button>
        }
        <div class="ipm-body"
             (wheel)="onWheel($event)"
             (mousedown)="onMouseDown($event)"
             (mousemove)="onMouseMove($event)"
             (mouseup)="onMouseUp()"
             (mouseleave)="onMouseUp()">
            <img #imgEl
                 [src]="imageUrl"
                 alt="Preview"
                 [style.transform]="transform"
                 [style.cursor]="isDragging ? 'grabbing' : (scale > 1 ? 'grab' : 'default')"
                 [style.transition]="isDragging ? 'none' : 'transform 0.15s ease'"
                 draggable="false" />
        </div>
        @if (hasGallery && currentIndex < images.length - 1) {
            <button class="ipm-nav-btn ipm-nav-next" (click)="goNext()" matTooltip="Next">
                <mat-icon>chevron_right</mat-icon>
            </button>
        }
    </div>

    @if (caption) {
        <div class="ipm-caption">{{ caption }}</div>
    }

    @if (hasGallery) {
        <div class="ipm-thumbnail-strip">
            @for (img of images; track img.url + $index; let i = $index) {
                <div class="ipm-thumb" [class.active]="i === currentIndex" (click)="selectThumbnail(i)">
                    <img [src]="img.url" alt="" />
                </div>
            }
        </div>
    }
</div>